import { useMemo } from "react";
import { motion } from "framer-motion";

export default function Ambient() {
  const flies = useMemo(
    () =>
      Array.from({ length: 14 }, (_, i) => ({
        id: i,
        left: `${(i * 67) % 100}%`,
        top: `${(i * 41) % 100}%`,
        size: 3 + ((i * 7) % 4),
        dur: 4 + ((i * 13) % 5),
        delay: (i * 0.7) % 4,
        color: i % 3 === 0 ? "#39FF14" : "#FF7A00",
      })),
    []
  );

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      {flies.map((f) => (
        <motion.span
          key={f.id}
          className="absolute rounded-full"
          style={{
            left: f.left,
            top: f.top,
            width: f.size,
            height: f.size,
            background: f.color,
            boxShadow: `0 0 10px ${f.color}`,
          }}
          animate={{ opacity: [0.15, 0.9, 0.15], y: [0, -30, 0] }}
          transition={{ duration: f.dur, repeat: Infinity, delay: f.delay, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}
